import {
    CHECKIN_CHECKOUT_CHANGE_USER_STATE
} from './actionTypes';

export function changeUserState(userState) {
    return {
        type: CHECKIN_CHECKOUT_CHANGE_USER_STATE,
        userState
    }
};